<template>    
    <div class="modal fade" id="static-update" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-md-dhk modal-dialog-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <Breadcrumb :breadcrumb="breadcrumb"/>
                    <div class="modal-title w-100">
                        <h2 class="title--1">
                            {{title}}
                        </h2>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text">
                            {{update_default_message}}
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <form class="col-12 p-0" @submit.prevent="form_submit_update(single_object.id, global_index)">

                        <FormDynamic
                            :form_format="form_format"
                            :form_data="single_object"
                            :array_options="array_options"
                            :for_update="true"
                        />

                        <!-- <div class="row space-button-2">
                            <pre>
                                {{ single_object }}
                            </pre>
                        </div> -->

                        <!-- <div class="row space-button-2">
                            <div class="col-md-6" style="padding:5px;">
                                <div>
                                    <button class="btn red button-modal-submit" style="color:white;" type="button" @click="modal_deletion()">Delete  <img class="ml-2" width="15px" src="/assets/img/trash.png" alt=""></button>
                                </div>
                            </div>
                            <div class="col-md-6" style="padding:5px;">
                                <div class="pull-right">
                                    <button class="btn blue button-modal-submit" style="color:white;"> Update  <img class="ml-2" width="15px" src="/assets/img/svg/add-w.svg" alt=""></button>
                                </div>
                            </div>
                        </div> -->
                        <CentralButtons />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import CentralButtons   from '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        CentralButtons,
    },

    data(){
        return{
            form_format:    FormResources.form_format,
            update_default_message: `In this view, you can view and modify the details of your selected item. To edit a field, simply click on it, make your changes, and hit save.`
        }
    },
    
    methods:{
        modal_deletion()
        {
            window.$('#static-deletion').modal('show')
            window.$('#static-update').modal('hide')
        },

    },

    mounted(){

    }
    
}
</script>
